import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.last-index-of";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import Vue from "vue";
import store from "@/store";
import ViewUI from "view-design";
import enUS from "view-design/dist/locale/en-US";
import zhCN from "view-design/dist/locale/zh-CN";
import VueI18n from "vue-i18n";
Vue.use(VueI18n); // 通过插件的形式挂载
// en.js

var L = require.context("@", true, /.*?\.i18n\.js$/);

var en = {};
var zh = {};
L.keys().forEach(function (key) {
  var slicing = key.substring(key.lastIndexOf("/") + 1);
  var name = slicing.substr(slicing, slicing.indexOf("."));
  var value = L(key).default;
  var e = {};
  var z = {};
  value.forEach(function (item) {
    e[item.name] = item.en;
    z[item.name] = item.zh;
  }); // console.log(e, z);

  en[name] = e;
  zh[name] = z;
});
var i18n = new VueI18n({
  locale: store.getters.language,
  // 语言标识
  messages: {
    zh: zh,
    // 中文语言包
    en: en // 英文语言包

  }
}); // 更新组件库本身的语言变化，支持国际化

function setLocale(lang) {
  if (lang === "en") {
    ViewUI.locale(enUS);
  } else if (lang === "zh") {
    ViewUI.locale(zhCN);
  }
}

setLocale(i18n.locale);
export default i18n;